import { NotifyHelper } from "../../../helpers/toast";
import { generateActionForKey, generateActions } from "../generateActions";
import { objHinhThucMienGiamDefine } from "../../action-types/hinh-thuc-mien-giam/IHinhThucMienGiamActionTypes";

export const hinhThucMienGiamActions = {
  ...generateActions(objHinhThucMienGiamDefine, "HINH_THUC_MIEN_GIAM"),
  ...generateActionForKey(
    objHinhThucMienGiamDefine,
    "HINH_THUC_MIEN_GIAM",
    "LOAD_ERROR",
    (m: any) => NotifyHelper.Error(m)
  ),
  ...generateActionForKey(
    objHinhThucMienGiamDefine,
    "HINH_THUC_MIEN_GIAM",
    "SAVE_SUCCESS",
    () => NotifyHelper.Success("Đã lưu")
  ),
  ...generateActionForKey(
    objHinhThucMienGiamDefine,
    "HINH_THUC_MIEN_GIAM",
    "SAVE_ERROR",
    (m: any) => NotifyHelper.Error(m)
  ),
  ...generateActionForKey(
    objHinhThucMienGiamDefine,
    "HINH_THUC_MIEN_GIAM",
    "DELETE_SUCCESS",
    () => NotifyHelper.Success("Đã xóa")
  ),
  ...generateActionForKey(
    objHinhThucMienGiamDefine,
    "HINH_THUC_MIEN_GIAM",
    "DELETE_ERROR",
    (m: any) => NotifyHelper.Error(m)
  ),
};

export const loadHinhThucMienGiamStart = hinhThucMienGiamActions.LOAD_START;
export const saveHinhThucMienGiamStart = hinhThucMienGiamActions.SAVE_START;
export const deleteHinhThucMienGiamStart = hinhThucMienGiamActions.DELETE_START;
export const showHinhThucMienGiamDetailModal = hinhThucMienGiamActions.SHOW_DETAIL_MODAL;
export const closeHinhThucMienGiamDetailModal = hinhThucMienGiamActions.CLOSE_DETAIL_MODAL;
export const showHinhThucMienGiamDeleteConfirm = hinhThucMienGiamActions.SHOW_DELETE_CONFIRM;
export const closeHinhThucMienGiamDeleteConfirm = hinhThucMienGiamActions.CLOSE_DELETE_CONFIRM;
export const changeHinhThucMienGiamSelectionIds = hinhThucMienGiamActions.CHANGE_SELECTION_IDS;
export const changeHinhThucMienGiamNamHocAction = hinhThucMienGiamActions.CHANGE_NAM_HOC;
